import React from 'react';
import { useState } from 'react';
import { useTranslator, useAppContext } from '@front-activerse/common-components';
import { useToast } from '@front-activerse/common-components';
import { Container, Row, Col, Alert, Button } from 'reactstrap';
import Layout from '../Layout/Layout';
import TitleBar from '../Layout/TitleBar';
import Loader from '../Layout/Loader';

interface IRemoveAccountContainer {
  sendRequestToRemoveAccount: () => Promise<any>;
  loading: boolean;
  activeSubscription: any;
  userEmail: string;
}

const RemoveAccountContainer: React.FC<IRemoveAccountContainer> = ({
  sendRequestToRemoveAccount,
  loading,
  activeSubscription,
  userEmail,
}) => {
  const { t } = useTranslator();
  const { toastError } = useToast();
  const [isEmailSent, setIsEmailSent] = useState(false);

  const {
    images: { doneIcon },
  } = useAppContext();

  const handleSendRequestToRemoveAccount = async () => {
    try {
      const response = await sendRequestToRemoveAccount();
      if (response.data.removeAccount.request.__typename === 'BasicMutationSuccess') {
        setIsEmailSent(true);
      }
    } catch (error) {
      toastError();
    }
  };

  const renderAlert = () => {
    const availableOperators = ['AppStore', 'GooglePlay', 'Stripe'];

    const uniqueActiveSubscription: any[] = [];
    activeSubscription.forEach((item: any) => {
      if (!uniqueActiveSubscription.some((sub) => sub.operator === item.operator)) {
        uniqueActiveSubscription.push(item);
      }
    });

    return uniqueActiveSubscription.map((item: any) => {
      if (availableOperators.includes(item.operator)) {
        let message;

        switch (item.operator) {
          case 'AppStore':
            message = t('deletingAccount.cancelSubscriptionInfo.iOS');
            break;
          case 'GooglePlay':
            message = t('deletingAccount.cancelSubscriptionInfo.android');
            break;
          case 'Stripe':
            message = t('deletingAccount.cancelSubscriptionInfo.stripe');
            break;
          default:
            message = '';
        }

        return (
          <Alert color="info" key={item.operator} fade={false}>
            <p
              className="mb-0"
              // dangerouslySetInnerHTML to allow HTML tags in translations
              dangerouslySetInnerHTML={{
                __html: message,
              }}
            />
          </Alert>
        );
      }

      return '';
    });
  };

  const renderSuccessSendEmail = () => {
    return (
      <div className="white-box">
        <h3 className="title-small medium mb-xl">
          <img src={doneIcon} className="me-2" style={{ width: '24px', height: 'auto' }} alt="" />
          {t('deletingAccount.checkEmailInstructionsNotification.title')}
        </h3>

        <p className="multi-line mb-0">
          {t('deletingAccount.checkEmailInstructionsNotification.content')}
        </p>
        <p className="mt-m mb-0">
          {t('deletingAccount.checkEmailInstructionsNotification.additionalContent')}
        </p>
      </div>
    );
  };
  return (
    <>
      <Layout>
        <TitleBar showBackBtn={false}>{t('deletingAccount.navbarTitle')}</TitleBar>
        <section className="page-template-remove-account full-height2">
          <Container>
            <Row>
              <Col xs="12" md={{ size: 6, offset: 3 }}>
                <div className="content-container">
                  {renderAlert()}
                  {!isEmailSent ? (
                    <div className="white-box">
                      <p className="mb-xl">
                        {t('deletingAccount.verificationEmailInfo.content', {
                          userEmail,
                        })}
                      </p>
                      <Button
                        color="primary"
                        className="w-100"
                        onClick={handleSendRequestToRemoveAccount}
                      >
                        {t('deletingAccount.verificationEmailInfo.send.button')}
                      </Button>
                    </div>
                  ) : (
                    renderSuccessSendEmail()
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Layout>
      {loading ? <Loader fixed="no" /> : ''}
    </>
  );
};

export default RemoveAccountContainer;
